module.exports = __webpack_public_path__ + "static/media/pic2.b6af651e.jpg";